<template>
<div class="kt-portlet">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>